import clsx from 'classnames';
import React, { ReactElement } from 'react';

import { BreadcrumbsProps } from './types';
import styles from './Breadcrumbs.module.scss';

export function Breadcrumbs(props: BreadcrumbsProps) {
	const children = React.Children.toArray(props.children);

	const wrapperClassNames = clsx(styles.breadcrumbsWrapper, props.wrapperClassName);

	return (
		<nav className={styles.breadcrumbsContainer}>
			<ol className={wrapperClassNames}>
				{children.map((child, i) =>
					React.cloneElement(child as ReactElement, {
						isCurrent: i === children.length - 1,
						isFirst: i === 0,
					})
				)}
			</ol>
		</nav>
	);
}
